import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWhatsappSolid = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m9.852 16.372.182.11c.77.456 1.654.695 2.555.698h.003c2.766 0 5.02-2.24 5.02-4.996a4.96 4.96 0 0 0-1.469-3.535 5 5 0 0 0-3.551-1.465c-2.766-.003-5.02 2.238-5.02 4.994 0 .942.263 1.862.767 2.658l.12.19-.508 1.842zm.892-6.968c.107.003.226.009.339.26.072.161.192.454.293.7.085.206.156.38.173.413.038.075.06.161.012.262l-.017.034a.8.8 0 0 1-.134.217l-.084.1c-.05.06-.1.12-.142.162-.075.075-.153.156-.066.306.086.15.39.643.84 1.04.482.43.902.611 1.114.703l.1.044c.15.075.24.064.327-.037.086-.101.376-.439.478-.588.098-.15.2-.124.338-.075.14.051.881.415 1.032.49l.083.04c.105.05.176.085.206.136.038.063.038.363-.086.715-.128.351-.745.689-1.02.715l-.08.008c-.255.031-.578.07-1.73-.383-1.42-.559-2.358-1.944-2.548-2.224l-.03-.045-.004-.004c-.086-.116-.614-.822-.614-1.55 0-.697.344-1.06.5-1.225q.016-.015.027-.03a.56.56 0 0 1 .403-.187c.101 0 .203 0 .29.003"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.333 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.478 10 10 10M6.5 18.298l.857-3.113a5.95 5.95 0 0 1-.805-3.007c0-3.316 2.712-6.011 6.04-6.011 1.616 0 3.134.625 4.273 1.761a5.95 5.95 0 0 1 1.767 4.253c0 3.315-2.712 6.01-6.043 6.01h-.003a6.07 6.07 0 0 1-2.888-.732z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWhatsappSolid;
